import type { HappeningNowPlatform } from "src/types/happeningNow";

/** Legacy docs without `platforms` behave as both. */
export function normalizeHappeningNowPlatforms(
  value: unknown,
): HappeningNowPlatform[] {
  if (!Array.isArray(value) || value.length === 0) {
    return ["android", "ios"];
  }
  const out = new Set<HappeningNowPlatform>();
  for (const v of value) {
    if (v === "android" || v === "ios") out.add(v);
  }
  if (out.size === 0) return ["android", "ios"];
  return Array.from(out).sort();
}

export function platformBooleansFromDoc(platforms: unknown): {
  android: boolean;
  ios: boolean;
} {
  const n = normalizeHappeningNowPlatforms(platforms);
  return { android: n.includes("android"), ios: n.includes("ios") };
}

/** Returns `null` if both would be off — caller should surface a validation error. */
export function platformsFromBooleans(
  android: boolean,
  ios: boolean,
): HappeningNowPlatform[] | null {
  if (!android && !ios) return null;
  const out: HappeningNowPlatform[] = [];
  if (android) out.push("android");
  if (ios) out.push("ios");
  return out;
}

export function platformsLabel(platforms: unknown): string {
  const n = normalizeHappeningNowPlatforms(platforms);
  if (n.length === 2) return "Android · iOS";
  return n[0] === "android" ? "Android" : "iOS";
}

export function platformsEqual(a: unknown, b: unknown): boolean {
  return (
    normalizeHappeningNowPlatforms(a).join(",") ===
    normalizeHappeningNowPlatforms(b).join(",")
  );
}
